import LandingPageContainer from 'components/LandingPage/LandingPageContainer'
import LandingPageData from 'components/LandingPage/LandingPageData'

export default {
  Container: LandingPageContainer,
  Data: LandingPageData,
}
